import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import { AuthProvider } from './context/AuthContext';
import Root from './Root';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Root />
    </AuthProvider>
  </React.StrictMode>
);
